/**
 * AI translation — language allowlist, validation, and the wire contract shared
 * by the translate endpoint and the frontend chat store. Keeping this in
 * @atlas/shared means backend validation and frontend picker can't drift.
 */
/** The closed set of target languages the picker offers and the API accepts. */
export const SUPPORTED_LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'zh', label: 'Chinese' },
    { code: 'es', label: 'Spanish' },
    { code: 'fr', label: 'French' },
    { code: 'de', label: 'German' },
    { code: 'ja', label: 'Japanese' },
    { code: 'ko', label: 'Korean' },
    { code: 'pt', label: 'Portuguese' },
    { code: 'it', label: 'Italian' },
    { code: 'vi', label: 'Vietnamese' },
];
export const DEFAULT_LANGUAGE = 'en';
/** Picker "off" sentinel — NOT a member of SUPPORTED_LANGUAGES; never sent to translate. */
export const ORIGINAL_LANGUAGE = 'original';
/** Lowercase, trim, and reduce a BCP-47 tag to its base subtag (en-US -> en). */
export function normalizeLanguage(input) {
    return (input ?? '').trim().toLowerCase().split(/[-_]/)[0] ?? '';
}
const SUPPORTED_SET = new Set(SUPPORTED_LANGUAGES.map((l) => l.code));
export function isSupportedLanguage(input) {
    return SUPPORTED_SET.has(normalizeLanguage(input));
}
/** Poll cadence contract for a `pending` result (FE and BE agree here, not by guess). */
export const AI_TRANSLATE_POLL_MS = 1000;
export const AI_TRANSLATE_POLL_MAX = 15; // ~15s before showing a manual retry
//# sourceMappingURL=translation.types.js.map